var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9667 5.93854C14.9667 5.60414 14.6955 5.3332 14.3613 5.3332H9.63333L8.06959 0.935336C7.98373 0.69427 7.75573 0.533203 7.49999 0.533203C7.24426 0.533203 7.01626 0.69427 6.93039 0.935336L5.36666 5.3332H0.638659C0.304525 5.3332 0.0333252 5.60414 0.0333252 5.93854C0.0333252 6.11827 0.113059 6.28867 0.251192 6.4036L3.76666 9.3332L2.19093 14.7007C2.17493 14.7553 2.16666 14.8121 2.16666 14.8692C2.16666 15.1991 2.43439 15.4665 2.76453 15.4665C2.89573 15.4665 3.02319 15.4233 3.12746 15.3436L7.49999 11.9999L11.8725 15.3436C11.9768 15.4233 12.1045 15.4665 12.2355 15.4665C12.5656 15.4665 12.8333 15.1991 12.8333 14.8692C12.8333 14.8121 12.8251 14.7556 12.8091 14.7009L11.2333 9.3332L14.7488 6.4036C14.8869 6.28867 14.9667 6.11827 14.9667 5.93854Z",
    fill: "url(#paint0_linear_2885_10135)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2885_10135",
    x1: 7.49999,
    y1: 0.533203,
    x2: 7.49999,
    y2: 15.4665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7367F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRating);
export default __webpack_public_path__ + "static/media/top-rating.413385744ca13d7016921c0f90d4282e.svg";
export { ForwardRef as ReactComponent };